export default {
    state: {
    },
    getters: {
        /**
         * Returns a promise which sets a timer that checks if window.zE, i.e the zendesk variable, has been loaded
         * Until its loaded, the timer keeps checking periodically. When its loaded, the timer stops and the
         * promise resolves. Can be called multiple times from multiple places and all promises should resolve
         */
        zendesk: (state) => () => {
            return new Promise(function(resolve) {
                const timer = window.setInterval(() => {
                    window.console.log("Checking ze", window.zE);
                    if (typeof window.zE === "undefined")
                        return;

                    window.clearInterval(timer);
                    resolve(window.zE);
                }, 200);
            })
        }

    },

    mutations: {},

    actions: {
        initChat(state) {
            state.getters.zendesk().then(zE => {
                window.console.log("Obtained zendesk", zE);
                zE('webWidget:on', 'open', () => {

                    const today = new Date();
                    const curHr = today.getHours();

                    let greeting = "";
                    if (curHr < 12)
                        greeting = "Good morning";
                    else if (curHr < 18)
                        greeting = "Good afternoon";
                    else
                        greeting = "Good evening";

                    //window.zE('webWidget', 'chat:send', `${greeting}! Welcome to Naminus. How are you today?`)
                });


                zE('webWidget:on', 'close', () => {
                    window.console.log("Chat closed");
                });

                state.dispatch("setChatLabel", "Chat");
                state.dispatch("setOfflineChatLabel", "Leave a message");
            })
        },

        addChatTag(state, tag) {
            const settings = {
                webWidget: {
                    chat: {
                        tags: [tag]
                    }
                }
            };
            window.console.log("adding zendesk tag", tag, settings);


            state.getters.zendesk().then(zE => {
                zE('webWidget', 'updateSettings', settings);
            })
        },

        /**
         * Updates the visitor path in zendesk since it doesn't get detected automatically due to this being a SPA
         */
        updateChatPath(state, deets) {
            state.getters.zendesk().then(zE => {
                window.console.log("Updating path", deets);
                zE('webWidget', 'updatePath', deets);
            });
        },

        setChatLabel(state, newLabel) {
            const settings = {
                webWidget: {
                    launcher: {
                        chatLabel: {
                            '*': newLabel
                        }
                    }
                }
            };

            state.getters.zendesk().then(zE => {
                zE('webWidget', 'updateSettings', settings);
            })
        },

        setOfflineChatLabel(state, newLabel){
            const settings = {
                webWidget: {
                    launcher: {
                        label: {
                            '*': newLabel
                        }
                    }
                }
            };

            state.getters.zendesk().then(zE => {
                zE('webWidget', 'updateSettings', settings);
            })
        }
    },

}